import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  width: '100%',
};

export const card = (isEnrichment = false): SxStyle => ({
  width: '100%',
  textAlign: isEnrichment ? 'left' : 'center',
  borderRadius: (p) => p.spacing(1),
  padding: (p) => p.spacing(0.75, isEnrichment ? 0 : 1),
  backgroundColor: (p) => (isEnrichment ? 'transparent' : p.palette.grey[200]),
});
